// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__2z97S","menu":"Navbar_menu__3AoOa"};